const DEFAULTS = {
  activeTab: 'e',
  packages: {
    e: null,
    mc: null,
  },
  addons: {
    ip: 0,
    ease: 3,
  },
  volume: {
    e: {
      essentials: 0,
      pro: 0,
    },
    mc: {
      basic: 0,
      advanced: 0,
    },
  },
  contacts: {
    basic: 0,
    advanced: 0,
  },
};

export default DEFAULTS;
